import { Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PublishDetails } from "./PublishDetails";
import { VisibilityPicker } from "./StudioDefaultsPanel";

// Review title, description, hashtags and visibility, then record + upload in one go.
export function PublishVideoDialog({ open, onOpenChange, privacy, setPrivacy, onPublish, commentCount, ...details }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="publish-video-dialog" className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Publish Video</DialogTitle></DialogHeader>
        <PublishDetails prefix="pub" className="" {...details} />
        <p className="text-xs text-zinc-500 leading-relaxed" data-testid="publish-video-note">
          {commentCount === 0 ? "You haven't added any comments yet. Use Enter Comment to add at least one before publishing. " : <>
            When you press Publish to YouTube, your video plays from the beginning and the AI voice reads your{" "}
            {commentCount} comment{commentCount === 1 ? "" : "s"} at {commentCount === 1 ? "its moment" : "their moments"}. It's recorded in this tab, then uploaded to your channel.{" "}
          </>}
          Your browser will ask what to share: choose <span className="text-zinc-800 font-medium">This Tab</span> and switch on <span className="text-zinc-800 font-medium">Also share tab audio</span>.
        </p>
        <div className="flex items-end justify-between gap-4 pt-2 border-t border-zinc-100">
          <VisibilityPicker privacy={privacy} setPrivacy={setPrivacy} />
          <button type="button" onClick={onPublish} disabled={!details.pubTitle.trim() || details.fullDescLen > 5000} data-testid="publish-to-youtube-btn"
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 disabled:opacity-40 text-white text-sm font-semibold rounded-[4px] px-6 py-3 transition-colors">
            <Upload size={15} /> Publish to YouTube
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
